import React from "react";
import mapboxgl from "mapbox-gl";
import { renderToString } from "react-dom/server";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"; //mapbox-gl/dist/mapbox-gl.css
import { Container } from "react-bootstrap";
mapboxgl.accessToken =
  "pk.eyJ1IjoiaGljYXJ1cyIsImEiOiJja2kyYThzenEwOGs3MnJtaWdkYnJkbGswIn0._ik3moCiiaseVdjpoSI1Pw";
const style_url = "mapbox://styles/hicarus/ckdqu5xo409xb19o149m5oc35/draft";
const layer_3d = {
  id: "3d-buildings",
  source: "composite",
  "source-layer": "building",
  filter: ["==", "extrude", "true"],
  type: "fill-extrusion",
  minzoom: 15,
  paint: {
    "fill-extrusion-color": "#aaa",
    "fill-extrusion-height": [
      "interpolate",
      ["linear"],
      ["zoom"],
      15,
      0,
      15.05,
      ["get", "height"],
    ],
    "fill-extrusion-base": [
      "interpolate",
      ["linear"],
      ["zoom"],
      15,
      0,
      15.05,
      ["get", "min_height"],
    ],
    "fill-extrusion-opacity": 0.6,
  },
}
function POSPreview(props) {
  return (
    <Container>
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col-6">
            <label>Image</label>
            <div
              className="image-input image-input-outline"
              id="kt_profile_avatar"
            >
              <div
                className="image-input-wrapper"
                style={{
                  backgroundImage: `url(${props.image || "https://www.pngkey.com/png/detail/247-2471442_google-maps-marker-grey.png"})`,
                }}
              ></div>
            </div>
          </div>
          <div className="col-6">
            <label>POS name</label>
            <h5><b>{props.name}</b></h5>

            {props.state && (<>
              <label>state</label>
              <h5><b>{props.state}</b></h5>
            </>)}
            {props.city && (<>
              <label>city</label>
              <h5><b>{props.city}</b></h5>
            </>)}
          </div>
        </div>
      </div>
    </Container>
  )
}

function PopUpMarker(props) {
  // const [agent, setAgent] = useState(null);
  const trace = props.trace;
  const agent = props.extra.agents.find((agent) => agent.uid === props.uid) ?? {}
  const default_tasks = ["checkin", "checkout"];
  const [task] = props.extra.tasks.filter(task => task.uid === trace.task_id)
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-6">
          <label>Agent Image</label>
          <div
            className="image-input image-input-outline"
            id="kt_profile_avatar"
          >
            <div
              className="image-input-wrapper"
              style={{
                backgroundImage: `url(${agent.photoURL})`,
              }}
            ></div>
          </div>
        </div>
        <div className="col-6">
          <label>Agent</label>
          <h5>{agent.name}</h5>
          <br />
          <label>
            {default_tasks.includes(trace.task_id) ? (
              <b>Action</b>
            ) : (
                <b>Task</b>

              )}
          </label>
          {default_tasks.includes(trace.task_id) ? (
            <h4>{trace.task_id === "checkin" ? "Check-in" : "Check-out"}</h4>
          ) : (
              <>
                <h4>{task?.name}</h4>
              </>
            )}
          <small>
            {new Date(props.trace.write._seconds * 1000).toLocaleString()}
          </small>
        </div>
      </div>
    </div>
  );
}
class Map extends React.Component {
  container = null;
  map = null;
  main_marker = new mapboxgl.Marker();
  markers = [];
  pos = [];
  constructor(props) {
    super(props);
    this.add3DStyle = this.add3DStyle.bind(this);
    this.addTraces = this.addTraces.bind(this);
    this.removeTraces = this.removeTraces.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this)
    this.addGeoSearch = this.addGeoSearch.bind(this);
    this.addPOS = this.addPOS.bind(this);
    this.state = {
      traces: props.traces,
      pos: props.pos

    };
  }
  componentDidUpdate() {
    // this.removeTraces();

    // this.removeMarkers()
    // this.addPOS()

    // this.addTraces();
    this.map.resize();
  }
  componentDidMount() {
    const { props } = this;
    const l = props.location || {};
    const center = (l.uid && l.coordinates)
      ? [l.coordinates.longitude, l.coordinates.latitude]
      : [-98.03358254195442, 38.04364344653945];
    this.map = new mapboxgl.Map({
      container: this.container,
      style: style_url,
      center: center,
      pitch: props.preview ? 30 : 0,
      zoom: props.zoom || 10,
    });
    this.map.on("load", () => {
      this.map.resize();

      this.add3DStyle();
      this.addGeoSearch();
      this.addTraces();
      this.addPOS();
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.on("click", (e) => {
        const { lng, lat } = e.lngLat;
        console.log({ lng, lat })

        this.map.flyTo({
          center: [lng, lat],
        });
        l.coordinates && this.main_marker.setLngLat([lng, lat]);
        props.controller &&
          props.controller({
            latitude: lat,
            longitude: lng,
          });
      });
    });
  }

  addPOS() {
    this.map.resize();

    const { props } = this
    if (!props?.pos?.length) {
      return;
    }
    const [center] = props.pos
    const { coordinates } = center
    this.map.flyTo({
      center: [coordinates.longitude ?? -98.03358254195442, coordinates.latitude ?? 38.04364344653945],
    });
    for (const pos of props.pos ?? []) {
      if (!pos.coordinates) {
        continue
      }
      const popup = new mapboxgl.Popup({ offset: 25 })
        .setMaxWidth("350px")
        .setHTML(
          renderToString(
            <POSPreview {...pos} />
          )
        );
      const marker = new mapboxgl.Marker();
      this.markers.push(marker);
      const { longitude, latitude } = pos.coordinates
      marker
        .setLngLat([longitude, latitude])
        .addTo(this.map)
        .setPopup(popup);
    }

  }
  add3DStyle() {
    const { props } = this;
    const l = props.location;
    const center = (l.uid && l.coordinates)
      ? [l.coordinates.longitude, l.coordinates.latitude]
      : [-77.22041669421316, 39.2113223518333];
    let layers = this.map.getStyle().layers;
    if (!l.coordinates) {
      props.controller &&
        props.controller({
          latitude: 0,
          longitude: 0,
        });
    }
    let labelLayerId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol" && layers[i].layout["text-field"]) {
        labelLayerId = layers[i].id;
        break;
      }
    }

    if (!props.preview && l.coordinates) {
      this.main_marker.setLngLat(center).addTo(this.map);
    }
    this.map.addLayer(
      layer_3d,
      labelLayerId
    );
    this.map.addSource("single-point", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });
  }
  addGeoSearch() {
    const { props } = this;

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false,
      placeholder: "Search for places",
      proximity: {},
    });

    if (!props.preview) {
      this.map.addControl(geocoder);
      geocoder.on("result", (e) => {
        const [lng, lat] = e.result.geometry.coordinates;
        props.controller &&
          props.controller({
            latitude: lat,
            longitude: lng,
          });
        props.setContext && props.setContext(e.result.context, e.result)
        this.main_marker.setLngLat(e.result.geometry.coordinates);
      });
    }
  }
  removeMarkers() {
    if (this.markers.length) {
      for (let i = this.markers.length - 1; i >= 0; i--) {
        this.markers[i].remove();
      }
    }
  }
  removeTraces() {
    const layer = this.map.getLayer("t-lines");
    if (layer !== undefined) {
      this.map.removeLayer("t-lines");

    }
    const source = this.map.getSource("traces-lines")
    if (source !== undefined) {
      this.map.removeSource("traces-lines");

    }
  }
  addTraces() {
    const { props } = this;
    if (!this.state.traces) {
      return
    }
    console.log(this.state.traces)
    const traces = this.state.traces
      .filter((user) => user.length)
      .map((user) => {
        const [info] = user;
        const color = info.color
        const uid = info.uid || info.user_id;
        const lines = user.map((trace) => {
          const { latitude, longitude } = trace.coordinates;
          const coordinates = [Number(longitude), Number(latitude)];
          if (trace.type === "task") {
            const popup = new mapboxgl.Popup({ offset: 25 })
              .setMaxWidth("350px")
              .setHTML(
                renderToString(
                  <PopUpMarker uid={uid} extra={props.extra} trace={trace} />
                )
              );
            const marker = new mapboxgl.Marker({
              color: color,
            });
            this.markers.push(marker);
            marker
              .setLngLat(coordinates)
              .addTo(this.map)
              .setPopup(popup);
          }
          return coordinates;
        });

        return {
          type: "Feature",
          properties: {
            color: color,
            description: uid,
            icon: "theatre",
          },
          geometry: {
            type: "LineString",
            coordinates: lines,
          },
        };
      });

    this.map.addSource("traces-lines", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: traces,
      },
    });
    this.map.addLayer({
      id: "t-lines",
      type: "line",
      source: "traces-lines",
      paint: {
        "line-width": 5,
        "line-color": ["get", "color"],
      },
    });

    this.map.on("click", "t-lines", async (e) => {
      // let coordinates = e.features[0].geometry.coordinates.slice();
      // const uid = e.features[0].properties.description;

      // Axios.get(
      //   `process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v2/users/find/${uid}`
      // ).then(({ data }) => {
      //   const user = data.payload;
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   }
      //   new mapboxgl.Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(renderToString(<Description user={user} />))
      //     .setMaxWidth("350px")
      //     .addTo(this.map);
      // });
    });
    this.map.on("mouseenter", "t-lines", () => {
      this.map.getCanvas().style.cursor = "pointer";
    });
    this.map.on("mouseleave", "t-lines", () => {
      this.map.getCanvas().style.cursor = "";
    });
  }

  render() {
    return (
      <div className="App">
        <div className="mapContainer">
          <div
            className="mapBox"
            ref={(el) => {
              this.container = el;
            }}
          />
        </div>
      </div>
    );
  }
}

export { Map };